import { create } from "zustand"
import type { RankingState } from "./types"

const useRankingStore = create<RankingState>((set) => ({
    rankings: undefined,
    asset: undefined,
    assetKey: undefined,
    sortingStep: undefined,
    sortingContext: undefined,
    setRankings: (rankings, asset, assetKey) =>
        set({
            rankings: rankings ?? undefined,
            asset: asset ?? undefined,
            assetKey: assetKey ?? undefined,
            sortingStep: undefined,
            sortingContext: undefined,
        }),
    setSortingResponse: (next_step, context) =>
        set({
            sortingStep: next_step ?? undefined,
            sortingContext: context ?? undefined,
        }),
    clearRankings: () =>
        set({
            rankings: undefined,
            asset: undefined,
            assetKey: undefined,
            sortingStep: undefined,
            sortingContext: undefined,
        }),
}))

export { useRankingStore }
